import React, { useState, useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/MainLayout/Layout.jsx';
import Login from './pages/Login.jsx';
import Dashboard from './pages/Dashboard.jsx';
import PatientRegister from './pages/PatientRegister.jsx';
import OPDList from './pages/OPDList';
import { ThemeProvider } from "./context/ThemeContext";
import UserCreation from './components/UserCreation.jsx';
import UserRolesManager from './components/UserRolesManager.jsx';

import UsersTable from './components/UsersTable.jsx';
import UserRolesTable from './components/UserRolesTable.jsx';
import IpdList from './pages/IpdList.jsx';
import IpdAdvanceForm from './pages/IpdAdvanceForm.jsx';
import IPDServiceDetailForm from './pages/IPDServiceDetailForm.jsx';
import IPDServiceDetailsTable from './components/IPDServiceDetailsTable.jsx';
import RoomForm from './pages/RoomForm.jsx';
import EditRoomForm from './pages/EditRoomForm.jsx';
import IPDRoomBookingForm from './pages/IPDRoomBookingForm.jsx';
import DepartmentForm from './pages/DepartmentForm.jsx';
import EditDepartmentList from './pages/EditDepartmentList.jsx';
import EmployeeForm from './pages/EmployeeForm.jsx';
import EditEmployeeList from './pages/EditEmployeeList.jsx';
import IPDRoomUpdate from './pages/IPDRoomUpdate.jsx';
import IPDAdvanceTable from './pages/IPDAdvanceTable.jsx';
import DischargeBill from './pages/DischargeBill.jsx';
import DischargeList from './pages/DischargeList.jsx';
import { API_BASE } from './config';
import BillingForm from './pages/BillingForm.jsx';
import BillList from './pages/BillList.jsx';
import Billpopup from './pages/Billpopup.jsx';
import BillingPayment from './pages/BillingPayment.jsx';
import ReportBillSummary from './pages/ReportBillSummary.jsx';
import ReportBillPayment from './pages/ReportBillPayment.jsx';
import ReportDue from './pages/ReportDue.jsx';
import Report from './pages/Report.jsx';
import ExPDTForm from './pages/ExPDTForm.jsx';
import AccountMasterForm from './pages/AccountMasterForm.jsx';
import BankDTForm from './pages/BankDTForm.jsx';
import ExPDTSearchForm from './pages/ExPDTSearchForm.jsx';
import DaybookReport from './pages/DaybookReport.jsx';
import DiscountAuthorityForm from './pages/DiscountAuthorityForm.jsx';
import PharmaCompanyForm from './pages/PharmaCompanyForm.jsx';
import MedCategoryDTForm from './pages/MedCategoryForm.jsx';
import MedBrandForm from './pages/MedBrandForm.jsx';
import MedicineForm from './pages/MedicineForm.jsx';
import MedicineSearchList from './pages/MedicineSearchList.jsx';
import VendorDTForm from './pages/VendorDTForm.jsx';
import MedPurchase from './pages/MedPurchase.jsx';
import MedicinePurchaseSearch from './pages/MedicinePurchaseSearch.jsx';
import MedicineSaleForm from './pages/MedicineSaleForm.jsx';
import MedicineSaleSearch from './pages/MedicineSaleSearch.jsx';
import MedicineSaleEditModal from './pages/MedicineSaleEditModal.jsx';
import StockOutForm from './pages/StockOutForm.jsx';
import StockOutSearch from './pages/StockOutSearch.jsx';
import DebitVoucher from './pages/DebitVoucher.jsx';
import DebitVoucherSearch from './pages/DebitVoucherSearch.jsx';
import DebitVoucherEditModal from './pages/DebitVoucherEditModal.jsx';
import PharmacyDashboard from './pages/PharmacyDashboard.jsx';
import InventoryReports from './pages/InventoryReports.jsx';
import SalesReports from './pages/SalesReports.jsx';
import PurchaseReports from './pages/PurchaseReports.jsx';
import ExpiryReports from './pages/ExpiryReports.jsx';
import FinancialReports from './pages/FinancialReports.jsx';
import DashboardReport from './pages/DashboardReport.jsx';
import ChargeMaster from './pages/ChargeMaster.jsx';

import AIChatPage from './components/AIChatPage.jsx';
import PrescriptionCreate from './pages/PrescriptionCreate.jsx';
import PrescriptionHistory from './pages/PrescriptionHistory.jsx';
import HospitalProfile from './components/HospitalProfile.jsx';
import ReceiptSettings from './components/ReceiptSettings.js';
import PackageMaster from './components/PackageMaster.js';
import IpdReport from './pages/IpdReport.jsx';
import UsgMasterPage from './pages/UsgMaster.jsx';
import UsgReportPage from './pages/UsgReport.jsx';
import UsgReportHistory from './pages/UsgReportHistory.jsx';
import USGReportHeaderConfig from './components/USGReportHeaderConfig.jsx';
import VendorPaymentForm from './pages/VendorPaymentForm.jsx';
import FinancialLedger from './pages/FinancialLedger.jsx';
import PharmacyLayout from './components/PharmacyMode/PharmacyLayout.jsx';
import AdminReportLayout from './components/AdminReportLayout.jsx';


import ClinicalLayout from './components/ClinicalMode/ClinicalLayout.jsx';


import BillingLayout from './components/BillingMode/BillingLayout';

import MasterLayout from './components/MasterMode/MasterLayout';

import GSTR1Report from './pages/MEDICINE/GSTR1Report.jsx';
import GSTR2Report from './pages/MEDICINE/GSTR2Report.jsx';
import MedicineDuePaymentCollect from './pages/MedicineDuePaymentCollect.jsx';
import MediVendorDueReport from './pages/MEDICINE/MediVendorDueReport.jsx';




function App() {
  // User state: null means logged out, object means logged in
  const [user, setUser] = useState(null);
  // Loading state taaki check karte waqt screen blink na kare
  const [loading, setLoading] = useState(true);

  // ✅ FIX: On app load, check for JWT token in sessionStorage (Not localStorage)
  useEffect(() => {
    // Kyunki Login.js sessionStorage use kar raha hai, yahan bhi wahi check karein
    const token = sessionStorage.getItem('token');

    if (token) {
      setUser({ isAuthenticated: true });
    } else {
      setUser(null);
    }

    setLoading(false);
  }, []);

  // Function to call after successful login
  const handleLoginSuccess = (user) => {
    setUser({ isAuthenticated: true });
  };

  // ✅ FIX: Logout function clears sessionStorage
  const handleLogout = () => {
    sessionStorage.clear(); // Token, LoginId, HospitalId sab saaf
    setUser(null);
  };

  if (loading) {
    // Jab tak token check ho raha ho, loading screen dikhayein
    return <div className="d-flex justify-content-center align-items-center vh-100">Loading...</div>;
  }

  // Agar logged out hai to login page dikhayein
  if (!user) {
    return (
      <Routes>
        <Route path="/login" element={<Login onLoginSuccess={handleLoginSuccess} />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    );
  }

  // User logged in hai, toh layout aur inner routes dikhayein
  return (
    <ThemeProvider>
   
      <Routes>
        <Route path="/" element={<Layout onLogout={handleLogout} />}>
          <Route index element={<Dashboard />} />
          <Route path="/profile" element={<HospitalProfile />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/ChargeMaster" element={<ChargeMaster />} />
          <Route path="/DepartmentForm" element={<DepartmentForm />} />
          <Route path="/EditDepartmentList" element={<EditDepartmentList />} />
          <Route path="/EmployeeForm" element={<EmployeeForm />} />
          <Route path="/EditEmployeeList" element={<EditEmployeeList />} />
          <Route path="/opd/list" element={<OPDList />} />
          <Route path="/opd/register" element={<PatientRegister />} />
          <Route path="/Room/Form" element={<RoomForm />} />
          <Route path="/Room/Booking/Form" element={<IPDRoomBookingForm />} />
          <Route path="/user/create" element={<UserCreation />} />
          <Route path="/user/Role/Creation" element={<UserRolesManager />} />
          <Route path="/UserRolesTable" element={<UserRolesTable />} />
          <Route path="/UsersTable" element={<UsersTable />} />
          <Route path="/IpdList" element={<IpdList />} />
          <Route path="/EditRoom" element={<EditRoomForm />} />
          <Route path="/IpdAdvance" element={<IpdAdvanceForm />} />
          <Route path="/IpdServiceDetails" element={<IPDServiceDetailForm />} />
          <Route path="/IpdServiceDetailsTable" element={<IPDServiceDetailsTable />} />
          <Route path="/IpdRoomUpdate" element={<IPDRoomUpdate />} />
          <Route path="/IPDAdvanceTable" element={<IPDAdvanceTable />} />
          <Route path="/DischargeBill" element={<DischargeBill />} />
          <Route path="/DischargeList" element={<DischargeList />} />
          <Route path="/BillingForm" element={<BillingForm />} />
          <Route path="/BillList" element={<BillList/>} />
          <Route path="/Billpopup" element={<Billpopup/>} />
          <Route path="/BillingPayment" element={<BillingPayment/>} />
          <Route path="/ReportBillSummary" element={<ReportBillSummary/>} />
          <Route path="/ReportBillPayment" element={<ReportBillPayment/>} />
          <Route path="/ReportDue" element={<ReportDue/>} />
          <Route path="/Report" element={<Report/>} />
          <Route path="/ExpenseForm" element={<ExPDTForm/>} />
          <Route path="/AccountMasterForm" element={<AccountMasterForm/>} />
          <Route path="/BankEntryForm" element={<BankDTForm/>} />
          <Route path="/ExPDTReport" element={<ExPDTSearchForm/>} />
          <Route path="/DaybookReport" element={<DaybookReport/>} />
          <Route path="/DiscountAuthorityForm" element={<DiscountAuthorityForm/>} />
          <Route path="/PharmaCompanyForm" element={<PharmaCompanyForm/>} />
          <Route path="/MedCategoryForm" element={<MedCategoryDTForm/>} />
          <Route path="/MedBrandForm" element={<MedBrandForm/>} />
          <Route path="/MedicineForm" element={<MedicineForm/>} />
          <Route path="/MedicineSearchList" element={<MedicineSearchList/>} />
          <Route path="/VendorForm" element={<VendorDTForm/>} />
          <Route path="/MedPurchase" element={<MedPurchase/>} />
          <Route path="/MedicinePurchaseSearch" element={<MedicinePurchaseSearch/>} />
          <Route path="/MedicineSaleForm" element={<MedicineSaleForm/>} />
          <Route path="/MedicineSaleSearch" element={<MedicineSaleSearch/>} />
          <Route path="/MedicineSaleEdit" element={<MedicineSaleEditModal/>} />
          <Route path="/StockOutForm" element={<StockOutForm/>} />
          <Route path="/StockOutSearch" element={<StockOutSearch/>} />
          <Route path="/DebitVoucher" element={<DebitVoucher/>} />
          <Route path="/DebitVoucherSearch" element={<DebitVoucherSearch/>} />
          <Route path="/DebitVoucherEdit" element={<DebitVoucherEditModal/>} />
          <Route path="/PharmacyDashboard" element={<PharmacyDashboard/>} />
          <Route path="/InventoryReports" element={<InventoryReports/>} />
           <Route path="/SalesReports" element={<SalesReports/>} />
            <Route path="/PurchaseReports" element={<PurchaseReports/>} />

             <Route path="/ExpiryReports" element={<ExpiryReports/>} />
              <Route path="/FinancialReports" element={<FinancialReports/>} />
              <Route path="/DashboardReport" element={<DashboardReport/>} />  
               <Route path="/PrescriptionCreate" element={<PrescriptionCreate/>} /> 

               <Route path="/ReceiptSettings" element={<ReceiptSettings/>} /> 
                <Route path="/PackagesMaster" element={<PackageMaster/>} /> 
                

               <Route path="/PrescriptionHistory" element={<PrescriptionHistory/>} />
              <Route path="/IpdReport" element={<IpdReport />} />
               <Route path="/UsgMasterPage" element={<UsgMasterPage />} />
                <Route path="/UsgReportPage" element={<UsgReportPage />} />
                <Route path="/UsgReportHistory" element={<UsgReportHistory />} />
                <Route path="/UsgReportHeaderConfig" element={<USGReportHeaderConfig />} />
                <Route path="/VendorPaymentForm" element={<VendorPaymentForm />} />
                 <Route path="/FinancialLedger" element={<FinancialLedger />} />

                  <Route path="GSTR1Report" element={<GSTR1Report />} />

              <Route path="/AIChatPage" element={<AIChatPage/>} />
                  
          
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>




        {/* =========================================
            2. DEDICATED PHARMACY ERP ROUTES 
            (No Main Sidebar, Uses Slim Top Navbar)
            ========================================= */}
        <Route path="/pharmacy" element={<PharmacyLayout />}>
          
          {/* Default Route for /pharmacy */}
          <Route index element={<Navigate to="dashboard-report" replace />} />
          <Route path="dashboard" element={<PharmacyDashboard />} />

          {/* Master Menus */}
          <Route path="category" element={<MedCategoryDTForm />} />
          <Route path="brand" element={<MedBrandForm />} />
          <Route path="medicine" element={<MedicineForm />} />
          <Route path="medicine-search" element={<MedicineSearchList />} />
          <Route path="pharma-company" element={<PharmaCompanyForm />} />
          <Route path="vendor" element={<VendorDTForm />} />

          {/* Purchase Menus */}
          <Route path="purchase" element={<MedPurchase />} />
          <Route path="purchase-search" element={<MedicinePurchaseSearch />} />
          <Route path="vendor-payment" element={<VendorPaymentForm />} />

          {/* Sales & POS Menus */}
          <Route path="sale" element={<MedicineSaleForm />} />
          <Route path="sale-search" element={<MedicineSaleSearch />} />
          <Route path="sale-edit" element={<MedicineSaleEditModal />} />
          {/* Note: Sale Return is handled within MedicineSaleForm by changing mode */}
          <Route path="return" element={<MedicineSaleForm />} /> 

          {/* Inventory Menus */}
          <Route path="stock-out" element={<StockOutForm />} />
          <Route path="stock-out-search" element={<StockOutSearch />} />
          <Route path="debit-voucher" element={<DebitVoucher />} />
          <Route path="debit-voucher-search" element={<DebitVoucherSearch />} />
          <Route path="debit-voucher-edit" element={<DebitVoucherEditModal />} />

          {/* Reports Menus */}
          <Route path="dashboard-report" element={<DashboardReport />} />
          <Route path="inventory-reports" element={<InventoryReports />} />
          <Route path="sales-reports" element={<SalesReports />} />
          <Route path="purchase-reports" element={<PurchaseReports />} />
          <Route path="expiry-reports" element={<ExpiryReports />} />
          <Route path="financial-reports" element={<FinancialReports />} />
          <Route path="financial-ledger" element={<FinancialLedger />} />
          <Route path="GSTR1Report" element={<GSTR1Report />} />
          <Route path="GSTR2Report" element={<GSTR2Report />} />
           <Route path="MedicineDuePaymentCollect" element={<MedicineDuePaymentCollect />} />
            <Route path="MediVendorDueReport" element={<MediVendorDueReport />} />

          
        </Route>




{/* =========================================
            3. DEDICATED ADMIN REPORTS CENTER
            ========================================= */}
        <Route path="/admin-reports" element={<AdminReportLayout />}>
          {/* Default redirect */}
          <Route index element={<Navigate to="billing-summary" replace />} />

          {/* Clinical & Wards */}
          <Route path="opd-list" element={<OPDList />} />
          <Route path="ipd-list" element={<IpdList />} />
          <Route path="ipd-report" element={<IpdReport />} />

          {/* Billing & Revenue */}
          <Route path="billing-summary" element={<ReportBillSummary />} />
          <Route path="billing-payment" element={<ReportBillPayment />} />
          <Route path="due-list" element={<ReportDue />} />

          {/* Accounts & Finance */}
          <Route path="expense-report" element={<ExPDTSearchForm />} />
          <Route path="daybook" element={<DaybookReport />} />
          <Route path="financial-ledger" element={<FinancialLedger />} />

          {/* Pharmacy Analytics */}
          <Route path="pharma-dashboard" element={<DashboardReport />} />
          <Route path="pharma-inventory" element={<InventoryReports />} />
          <Route path="pharma-purchase" element={<PurchaseReports />} />
          <Route path="pharma-sales" element={<SalesReports />} />
          <Route path="pharma-expiry" element={<ExpiryReports />} />
          <Route path="pharma-financial" element={<FinancialReports />} />
        </Route>




        {/* =========================================
            4. DEDICATED CLINICAL / RECEPTION DESK MODE
            ========================================= */}
        <Route path="/clinical" element={<ClinicalLayout />}>
          <Route index element={<Navigate to="register" replace />} />
          
          {/* In paths ke aage aapne jo components already banaye hain (jaise PatientRegister, OPDList), unhi ko link karenge */}
          <Route path="register" element={<PatientRegister />} />
          <Route path="opd-list" element={<OPDList />} />
          <Route path="ipd-list" element={<IpdList />} />
     {/* Room Booking & List */}
          <Route path="room-booking" element={<IPDRoomBookingForm />} />
          <Route path="room-update" element={<IPDRoomUpdate />} /> {/* ✅ List Route Added */}
          
          {/* Service Details & List */}
          <Route path="service-details" element={<IPDServiceDetailForm />} />
          <Route path="service-table" element={<IPDServiceDetailsTable />} /> {/* ✅ List Route Added */}
          
          {/* Advance & List */}
          <Route path="advance" element={<IpdAdvanceForm />} />
          <Route path="advance-table" element={<IPDAdvanceTable />} />
          <Route path="discharge-bill" element={<DischargeBill />} />
          <Route path="discharge-list" element={<DischargeList />} />
        </Route>



        {/* =========================================
            5. DEDICATED BILLING DESK MODE
            ========================================= */}
        <Route path="/billing" element={<BillingLayout />}>
          <Route index element={<Navigate to="form" replace />} />
          
          <Route path="form" element={<BillingForm />} />
          <Route path="list" element={<BillList />} />
          <Route path="popup" element={<Billpopup />} />
          <Route path="payment" element={<BillingPayment />} />
          <Route path="due-list" element={<ReportDue />} />
          <Route path="summary" element={<ReportBillSummary />} />
          <Route path="payment-report" element={<ReportBillPayment />} />
          <Route path="report" element={<Report />} />
        </Route>





       {/* =========================================
            6. DEDICATED CENTRAL MASTER MODE
            ========================================= */}
        <Route path="/master" element={<MasterLayout />}>
          <Route index element={<Navigate to="user/create" replace />} />
          
          {/* Admin Forms & Lists */}
          <Route path="user/create" element={<UserCreation />} />
          <Route path="users-list" element={<UsersTable />} />  {/* ✅ List added here */}
          
          <Route path="user/roles" element={<UserRolesManager />} />
          <Route path="roles-list" element={<UserRolesTable />} /> {/* ✅ List added here */}
          
          {/* Infra Forms & Lists */}
          <Route path="department" element={<DepartmentForm />} />
          <Route path="department-list" element={<EditDepartmentList />} /> {/* ✅ List added here */}
          
          <Route path="employee" element={<EmployeeForm />} />
          <Route path="employee-list" element={<EditEmployeeList />} /> {/* ✅ List added here */}
          
          <Route path="room" element={<RoomForm />} />
          <Route path="room-list" element={<EditRoomForm />} /> {/* ✅ List added here */}
          
          {/* Accounts & Finance */}
          <Route path="account-master" element={<AccountMasterForm />} />
          <Route path="bank-entry" element={<BankDTForm />} />
          <Route path="charge-master" element={<ChargeMaster />} />
          <Route path="discount-authority" element={<DiscountAuthorityForm />} />
          <Route path="packages" element={<PackageMaster />} />
          
          {/* Pharmacy Forms & Lists */}
          <Route path="medicine-category" element={<MedCategoryDTForm />} />
          <Route path="medicine-brand" element={<MedBrandForm />} />
          <Route path="medicine-form" element={<MedicineForm />} />
          <Route path="medicine-list" element={<MedicineSearchList />} /> {/* ✅ List added here */}
          <Route path="pharma-company" element={<PharmaCompanyForm />} />
          <Route path="vendor" element={<VendorDTForm />} />
          
          {/* Clinical/Lab */}
          <Route path="usg-master" element={<UsgMasterPage />} />
          <Route path="usg-header" element={<USGReportHeaderConfig />} />
        </Route>



      </Routes>


    
    </ThemeProvider>
  );
}

export default App;